import settings from '../liferay/settings';
import ApiUtils from '../liferay/ApiUtils';
import VirtuosoApiUtils from '../virtuoso/ApiUtils';
import virtuosoSettings from '../virtuoso/settings';
import { LinguisticSystemRequest } from '../virtuoso/request';

/** Специальный action для определения значений по-умолчанию
 * Определяет graph, текущий язык */
const Settings = {
    EMPTY: () => ({
        type: "Settings.EMPTY"
    }),    
    LOAD_STARTED: () => ({
        type: "Settings.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "Settings.LOAD_ERROR",
        error
    }),
    GRAPH: graph => ({
        type: "Settings.GRAPH", 
        graph
    }),
    LANG: lang => ({
        type: "Settings.LANG", 
        lang
    }),
    SIGNED: isSignedIn => ({
        type: "Settings.SIGNED", 
        isSignedIn
    }),
    GROUPS: groups => ({
        type: "Settings.GROUPS", 
        groups
    }),
    INFO: info => ({
        type: "Settings.INFO", 
        info
    }),
    NAMESPACE: (prefix, namespace) => ({
        type: "Settings.NAMESPACE",  prefix, namespace
    }),
    NAMESPACES: (namespaces) => ({
        type: "Settings.NAMESPACES",  namespaces
    }),
    LINGUISTIC_SYSTEM: (distinct, ordered, bindings) => ({
      type: "Settings.LINGUISTIC_SYSTEM", 
      langs: [...new Set(bindings
                  .map(item => item.s?.value)
                  .filter(Boolean)
                  .map(value => {
                    const slashIndex = value.lastIndexOf("/");
                    const hashIndex = value.lastIndexOf("#");
                    const cutIndex = Math.max(slashIndex, hashIndex);

                    return cutIndex >= 0 ? value.slice(cutIndex + 1) : value;
                  })
              )]
    }),

    /** Загрузить список групп текущиего пользователя */
    getUserGroups: () => dispatch => {
      const options = {...settings.options};
      options['type']= 'text';
      const formData = {
        'cmd': JSON.stringify({'/mpo.mpo/get_user_groups':{}})
      }
      //console.log("SettingsActions.js getUserGroups!", formData);
      return ApiUtils.postToLifeRay721(formData, options)
        .then (response =>{
          const groups = JSON.parse(JSON.parse(response));
          //console.log("SettingsActions.js getUserGroups!", JSON.stringify(groups));
          if (groups.hasOwnProperty("Licensed")){
            if (!groups["Licensed"]){
              dispatch(Settings.getInfo());
            }
          }
          //const { count, items, years} = response;
          dispatch(Settings.GROUPS(groups));
          return Promise.resolve(groups);
        });
    },

    /** Загрузить информацию о текущей установке */
    getInfo: () => dispatch => {
      const options = {...settings.options};
      options['type']= 'text';
      const formData = {
        'cmd': JSON.stringify({'/mpo.mpo/get_info':{}})
      }
      //console.log("SettingsActions.js getUserGroups!", formData);
      return ApiUtils.postToLifeRay721(formData, options)
        .then (response =>{
          const info = JSON.parse(JSON.parse(response));
          //console.log("SettingsActions.js getInfo!", JSON.stringify(info));
          dispatch(Settings.INFO(info));
          return Promise.resolve(info);
        });
    },

    // Загрузить информацию о заголовках
    loadLinguisticSystem: (catalogIRI=virtuosoSettings.catalog.iri) => dispatch => {
        const options = {...virtuosoSettings.options};
        const request = LinguisticSystemRequest(catalogIRI);
        return VirtuosoApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(Settings.LINGUISTIC_SYSTEM(distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                return Promise.reject(e);
            });
    },

    /** Загрузить список пространства имён  */
    loadNamespaces: () => dispatch => {
        const options = {...settings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/get_namespaces':{}}),
        }
        dispatch(Settings.LOAD_STARTED());
        return ApiUtils.postToLifeRay721(formData, options)
          .then ((response) =>{            
            const namespaces = Object.entries(response)
              .sort(([ns1], [ns2]) => ns1.localeCompare(ns2))
              .map(([ns, uri]) => ({ns,uri}));
            dispatch(Settings.NAMESPACES(namespaces));
            return Promise.resolve(response);
          })
          .catch(e => { 
                dispatch(Settings.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
          });
    },

  /** Добавить новый элемент в список пространства имён */
  addNamespace: (prefix, uri) => dispatch => {
    const options = {...settings.options};
    const formData = {
      'cmd': JSON.stringify({'/mpo.mpo/add_namespace':{}}),
      'namespace': prefix,
      'uri': uri
    }
    dispatch(Settings.LOAD_STARTED());
    return ApiUtils.postToLifeRay721(formData, options)
      .then ((response) =>{
        if (response.hasOwnProperty(prefix))
          dispatch(Settings.NAMESPACE(response));
        else
          return Promise.reject(response);
        return Promise.resolve(response);
      })
      .catch(e => { 
        dispatch(Settings.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
  },

  /** Удалить элемент из списка пространства имён */
  deleteNamespace: (prefix) => dispatch => {
    const options = {...settings.options};
    const formData = {
      'cmd': JSON.stringify({'/mpo.mpo/delete_namespace':{}}),
      'namespace': prefix
    }
    dispatch(Settings.LOAD_STARTED());
    return ApiUtils.postToLifeRay721(formData, options)
      .then ((response) =>{
        if (response.hasOwnProperty('deleted') && response['deleted'] == prefix)
          return Promise.resolve(response);
        else
          return Promise.reject(response);
      })
      .catch(e => { 
        dispatch(Settings.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
  }

}

export default Settings;
